// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionActivityRecordResponseDto
 */
export interface IContributionActivityRecordResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionActivityRecordResponseDto
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    processing_status?: IContributionActivityRecordResponseDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    tax_type?: IContributionActivityRecordResponseDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    tax_year?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionActivityRecordResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    employee_full_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IContributionActivityRecordResponseDto
     */
    contribution_date_on?: Date;
    /**
     * 
     * @type {number}
     * @memberof IContributionActivityRecordResponseDto
     */
    ee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionActivityRecordResponseDto
     */
    er_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionActivityRecordResponseDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContributionActivityRecordResponseDto
     */
    disabled?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IContributionActivityRecordResponseDtoProcessingStatusEnum {
    INITIATED = 'INITIATED',
    VALIDATED = 'VALIDATED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    SKIPPED = 'SKIPPED',
    DECLINED = 'DECLINED'
}
/**
* @export
* @enum {string}
*/
export enum IContributionActivityRecordResponseDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}


/**
 * Check if a given object implements the IContributionActivityRecordResponseDto interface.
 */
export function instanceOfIContributionActivityRecordResponseDto(value: object): value is IContributionActivityRecordResponseDto {
    return true;
}

export function IContributionActivityRecordResponseDtoFromJSON(json: any): IContributionActivityRecordResponseDto {
    return IContributionActivityRecordResponseDtoFromJSONTyped(json, false);
}

export function IContributionActivityRecordResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionActivityRecordResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_id': json['record_id'] == null ? undefined : json['record_id'],
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'employee_full_name': json['employee_full_name'] == null ? undefined : json['employee_full_name'],
        'contribution_date_on': json['contribution_date_on'] == null ? undefined : (new Date(json['contribution_date_on'])),
        'ee_contribution_amount': json['ee_contribution_amount'] == null ? undefined : json['ee_contribution_amount'],
        'er_contribution_amount': json['er_contribution_amount'] == null ? undefined : json['er_contribution_amount'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function IContributionActivityRecordResponseDtoToJSON(json: any): IContributionActivityRecordResponseDto {
    return IContributionActivityRecordResponseDtoToJSONTyped(json, false);
}

export function IContributionActivityRecordResponseDtoToJSONTyped(value?: IContributionActivityRecordResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_id': value['record_id'],
        'processing_status': value['processing_status'],
        'plan_code': value['plan_code'],
        'plan_name': value['plan_name'],
        'tax_type': value['tax_type'],
        'tax_year': value['tax_year'],
        'employee_id': value['employee_id'],
        'employee_full_name': value['employee_full_name'],
        'contribution_date_on': value['contribution_date_on'] == null ? undefined : ((value['contribution_date_on']).toISOString().substring(0,10)),
        'ee_contribution_amount': value['ee_contribution_amount'],
        'er_contribution_amount': value['er_contribution_amount'],
        'memo': value['memo'],
        'subsidiary_name': value['subsidiary_name'],
        'disabled': value['disabled'],
    };
}

